export function getFeedbackFormAction() {
  return process.env.REACT_APP_FEEDBACK_FORM_ACTION?.trim() || "";
}
